import{b as a}from"../chunk-VLB7YHLV.mjs";import"../chunk-LSZKOVGW.mjs";import"../chunk-SGUETU3K.mjs";export{a as faker};
